<template>
    <b-modal
        :id="modalId"
        modal-class="custom-modal"
        centered
        hide-header
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
    >
        <div class="area-modal">
            <div class="content-modal">
                <div class="icon-header">
                    <img src="@/assets/megaWish/success.png" />
                </div>
                <div class="header" v-html="localText.titleSuccess"></div>
                <div class="bottom-modal">
                    <div class="btn-close-border btn-cancel" @click="clickOk()">
                        {{ localText.btnText }}
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>
<script>
export default {
    name: "AlertModal",
    props: {
        lbl: Object,
        busSerialModal: Object,
        afterConfirmLastModal: Function
    },
    data: function() {
        return {
            localText: {},
            modalId: "modal-alert-id"
        };
    },
    mounted: function() {
        this.localText = this.lbl.after_redeem;
        this.busSerialModal.$on("showSerialModal", this.showModal);
        this.busSerialModal.$on("hideSerialModal", this.closeSerialModal);
    },
    methods: {
        showModal: function() {
            this.$bvModal.show(this.modalId);
        },
        clickOk: function() {
            this.afterConfirmLastModal("success");
            this.$bvModal.hide(this.modalId);
        }
    }
};
</script>
<style lang="scss" scoped>
@import "./modal.scss";
.modal-open .modal {
    overflow: hidden;
}
.area-modal {
    .content-modal {
        .icon-header {
            position: absolute;
            width: 100%;
            top: -40px;
            img {
                width: 80px;
                display: block;
                margin: 0 auto;
            }
        }
        .header {
            padding-top: 100px;
            padding-bottom: 50px;
            color: #000;
            font-size: 1.6rem;
        }
    }
}
</style>
